import { Stack, Typography } from "@mui/material";
import { useAppDispatch } from "hooks/useReduxHooks";
import { useParams } from "react-router-dom";
import { AccountAnalyticBlock } from "../components/accounts";
import { CompanyActionBlock } from "../components/company";
import { MembersBlock } from "../components/company/MembersBlock";
import { campaignsApi, useGetCampaignDetailsQuery } from "../api";
import { useEffect } from "react";
import { useNotFoundRedirect } from "../hooks";
import { AnalysisStatus } from "../types/companyTypes";

const checkInProgress = (currentStatus: string) => {
  return [AnalysisStatus.queued, AnalysisStatus.in_progress].some(
    (el) => el === currentStatus,
  );
};

export const AccountPage = () => {
  const { account_id, campaign_id } = useParams();
  const dispatch = useAppDispatch();

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  const { data, error } = useGetCampaignDetailsQuery(
    { account_id: account_id! },
    { skip: !account_id },
  );

  useNotFoundRedirect({ error });

  const refetchDataHandler = () => {
    dispatch(campaignsApi.util.invalidateTags(["company", "activities"]));
  };

  if (!campaign_id || !data) {
    return null;
  }

  const {
    status,
    progress,
    is_analyzed,
    scraping_update_status,
    scraping_status,
    total_members,
    can_be_analyzed,
    output: {
      summary: {
        total: { original, enriched },
      },
    },
  } = data;

  const isAnalyze = checkInProgress(status);
  const isScraping = checkInProgress(scraping_status);
  const isScrapingUpdate = checkInProgress(scraping_update_status);

  const isProcessingDisabled = isAnalyze || isScraping || isScrapingUpdate;

  return (
    <>
      {account_id && (
        <CompanyActionBlock
          account_id={account_id}
          campaign_id={campaign_id}
          account={data}
          hasContacts={total_members > 0}
          canAnalyzeAll={can_be_analyzed || status === "in_progress"}
          progress={progress}
          is_analyzed={is_analyzed}
          status={status}
          successCallBack={refetchDataHandler}
          isDisabled={isProcessingDisabled}
        />
      )}
      <Stack gap="24px">
        <Typography
          variant="h4"
          color="custom.textDarkBlue"
          sx={{ fontSize: "16px", lineHeight: "24px", fontWeight: 500 }}
        >
          Account Analysis Results
        </Typography>
        <AccountAnalyticBlock />
      </Stack>

      <MembersBlock
        initCommitteeSelected={
          original.committee_members + enriched.committee_members
        }
        initClusterSelected={
          original.cluster_members + enriched.cluster_members
        }
      />
    </>
  );
};
